import { Tabs } from '@app/infrastructure/application/model/Tabs';
import { createContext } from 'react';

export const TabsContext = createContext<Tabs>({
    activeTabId: '',
    setActiveTabId: () => {},
});
